// extracted by mini-css-extract-plugin
export default {"addBtn":"AddTitle_addBtn__56gu6"};